import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState } from "react";

import { VismedicasUpdate } from "./VismedicasUpdate";
import { VismedicasDelete } from "./VismedicasDelete";

export function VismedicasEdit(props) {
  const vismedicas = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = vismedicas.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [vismedResp, setVismedResp] = useState(vismedicas.meta?.vismedResp);
  const [vismedFecha, setVismedFecha] = useState(vismedicas.meta?.metaFecha);
  const vismedHora = vismedicas.meta?.vismedHora;
  // const [vismedHora, setVismedHora] = useState(vismedicas.meta?.vismedHora);
  const [vismedObs, setVismedObs] = useState(vismedicas.meta?.vismedObs);
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let vismedicasId = vismedicas.id;

  const vismedDate = new Date(vismedicas.date);
  const diffDate = Math.abs(new Date() - vismedDate) / 36e5;

  const submitVismedicas = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await VismedicasUpdate(
        vismedResp,
        vismedFecha,
        vismedHora,
        vismedObs,
        tratamientoId,
        pacienteId,
        vismedicasId
      ).then(
        (val) => {
          // window.location.replace(
          //   `../../visitas-medicas/${val.id}`
          // );
          navigate(
            `../${tratamientoId}/hospitalizacion/visitas-medicas/${vismedicasId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await VismedicasDelete(vismedicasId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        {vismedicas.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' onSubmit={submitVismedicas}>
            <fieldset id='disabledContainer'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='vismedResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='vismedResp'
                      required
                      type='text'
                      value={vismedResp}
                      onChange={(e) => setVismedResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='vismedFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='vismedFecha'
                      required
                      type='date'
                      value={vismedFecha}
                      onChange={(e) => setVismedFecha(e.target.value)}
                    />
                  </div>
                </div>
                {/* <div className='field'>
                  <label htmlFor='vismedHora'>Hora de Visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='vismedHora'
                      required
                      type='time'
                      value={vismedHora}
                      onChange={(e) => setVismedHora(e.target.value)}
                    />
                  </div>
                </div> */}
              </div>
              <div className='field'>
                <label htmlFor='vismedObs'>Observaciones</label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='vismedObs'
                    id='vismedObs'
                    value={vismedObs}
                    onChange={(e) => setVismedObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
        {((diffDate <= 72) || (props.userRole.includes('administrador')))  &&
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        }
        <Link
          className='button is-link is-light'
          to={`../${tratamientoId}/hospitalizacion/visitas-medicas/${vismedicas.id}`}
        >
          Cancelar
        </Link>
        {(props.userRole.includes('administrador'))  &&
        <button 
        className="button is-danger" 
        id="deleteButton" 
        onClick={deleteItem}
        disabled={isDeletingButton}
        >
        {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
        }
      </div>
      }
    </>
  );
}
